import script from "./BusinessInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessInfo.vue?vue&type=script&setup=true&lang=js"

import "./BusinessInfo.vue?vue&type=style&index=0&id=181d16d5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-181d16d5"]])

export default __exports__